import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthStorageService } from '../storage/auth-storage.service';
import { AuthService } from '../services/auth.service';

export function jwtInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const storage = inject(AuthStorageService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = storage.getToken();
  const isAuthEndpoint = req.url.includes('/api/v1/auth/login');
  const authReq = token && !isAuthEndpoint
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isAuthEndpoint) {
        authService.logout();
        return throwError(() => error);
      }
      if (error.status === 403) {
        void router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
}
